import { TemplateRef, Component, OnInit, AfterViewInit, Inject, ViewEncapsulation, ViewChild, HostListener, ElementRef } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators } from '@angular/forms';
// import { NgSelectModule} from '@ng-select/ng-select';

import { TawktoService } from "../../core/services/tawkto.service";
import { EventService } from '../../core/services/event.service';
import { AuthenticationService } from '../../core/services/auth.service';
import { LandaService } from '../../core/services/landa.service';
import { ClientStatusService } from '../../core/services/client-status.service';
import Swal from 'sweetalert2';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { TranslateService } from '@ngx-translate/core';
import * as introJs from 'intro.js/intro.js';
import { SwUpdate } from "@angular/service-worker";
import {
    environment
} from '../../../environments/environment';

import { DOCUMENT } from '@angular/common';
declare const run: any;
@Component({
    selector: 'app-horizontaltopbar',
    templateUrl: './horizontaltopbar.component.html',
    styleUrls: ['./horizontaltopbar.component.scss'],
})

/**
 * Horizontal Topbar and navbar specified
 */
export class HorizontaltopbarComponent implements OnInit, AfterViewInit {
    @ViewChild('settingKaryawanTrial') settingKaryawanTrial: TemplateRef<any>; // Note: TemplateRef
    @ViewChild('settingAkun') settingAkun: TemplateRef<any>; // Note: TemplateRef
    // @ViewChild('settingTipe') settingTipe : TemplateRef<any>; // Note: TemplateRef
    @ViewChild('modalGPasswordVerifiedEmail') modalGPasswordVerifiedEmail: TemplateRef<any>; // Note: TemplateRef
    @ViewChild('modalTutorialAwal') modalTutorialAwal: TemplateRef<any>; // Note: TemplateRef
    @ViewChild('settingAkunBaru') settingAkunBaru: TemplateRef<any>;
    @ViewChild('reminderMasaAktif') reminderMasaAktif: TemplateRef<any>;
    @ViewChild('modalPerpanjang') modalPerpanjang: TemplateRef<any>;
    @ViewChild('reminderInvoicePending') reminderInvoicePending: TemplateRef<any>;
    @ViewChild('modalPerpanjangInvoicePending') modalPerpanjangInvoicePending: TemplateRef<any>;
    @ViewChild('confirmKey') confirmKey: TemplateRef<any>; // Note: TemplateRef
    @ViewChild('discardKey') discardKey: TemplateRef<any>; // Note: TemplateRef

    introJS = introJs();

    element;
    configData;
    user;
    datauser: any;

    // ==== WhatsApp / Connect Channel (UI only, dummy) ====
    /** Apakah channel WhatsApp sudah terhubung. Dummy state, defaultnya belum. */
    waConnected = false;
    /** Step form connect channel: 1 = isi data channel, 2 = scan QR, 4 = info terhubung (3/sukses pakai Swal) */
    connectStep = 1;
    connectModel: { platform: string; channelName: string; aiAgent: string };
    platformList = ['WhatsApp'];
    aiAgentList = ['Humanis Agent'];
    /** Info akun WhatsApp yang terhubung (dummy). */
    connectedInfo: { accountName: string; phone: string; lastConnected: string } = {
        accountName: '',
        phone: '',
        lastConnected: '',
    };
    /** Daftar konteks chat yang dapat dibalas otomatis oleh AI Agent (dummy). */
    agentContexts = [
        { title: 'Informasi Absensi', desc: 'Menjawab pertanyaan seputar kehadiran, jam masuk, dan jam pulang karyawan.', sample: 'Halo, jam berapa saya absen masuk hari ini?', response: 'Hai! Hari ini kamu absen masuk pukul 08.02 WIB. Semangat bekerja! 😊', expanded: false },
        { title: 'Pengajuan Cuti & Izin', desc: 'Membantu pengajuan cuti/izin dan mengecek sisa cuti tahunan.', sample: 'Saya mau ajukan cuti tanggal 10-12 Juli, sisa cuti saya berapa?', response: 'Sisa cuti tahunan kamu 8 hari. Pengajuan cuti 10-12 Juli sudah saya catat dan diteruskan ke atasan untuk persetujuan.', expanded: false },
        { title: 'Slip Gaji', desc: 'Mengirimkan slip gaji terbaru karyawan.', sample: 'Tolong kirimkan slip gaji saya bulan ini.', response: 'Baik, slip gaji bulan ini sudah saya kirimkan ke email kamu ya. 📄', expanded: false },
        { title: 'Reimbursement', desc: 'Mengecek status dan membantu pengajuan reimbursement.', sample: 'Bagaimana status pengajuan reimbursement saya?', response: 'Pengajuan reimbursement kamu sebesar Rp350.000 sedang dalam proses review oleh Finance.', expanded: false },
        { title: 'Pengumuman', desc: 'Menyampaikan informasi dan pengumuman perusahaan.', sample: 'Apakah ada pengumuman terbaru dari HR?', response: 'Ada 1 pengumuman baru: "Libur Cuti Bersama Idul Fitri 21 Maret 2026". Cek detailnya di aplikasi ya.', expanded: false },
    ];

    aksesPerusahaan: any = [];
    listPerusahaan: any;
    listPerusahaanTerhapus: any;
    dataPerusahaan: {
        jadwal_version
    }
    jumlahSemuaPerusahaan: any;
    jumlahPerusahaanTerhapus: any;
    is_tampil_paket: boolean;
    imageSrc: any;
    adafoto: any;
    qrcode: any;
    fa_qr: any;
    jenis_paket: any;
    faqr1: any;
    faqr2: any;
    faqr3: any;
    faqr4: any;
    faqr5: any;
    faqr6: any;
    idkaryawanfilter: any;
    model: {
        id;
        kode;
        nama;
        username;
        twofa;
        password;
        repassword;
        validasi;
        validasi_error;
    };
    listPengumuman: any = [];
    dataModalPengumuman: {
        judul,
        isi,
        tanggal,
        penulis
    }
    listJumlahKaryawan: any = [];
    clientDetail: {
        max_perusahaan,
        max_karyawan,
        nama_paket,
        jumlah_perusahaan,
        tgl_aktif,
        allmaxkaryawan,
        jenis_usaha,
        nama,
        email,
        status,
        paket_id,
        masa_aktif,
        is_paket_custom
    };

    detailproject: any;
    listKaryawanFilter: any;
    max_perusahaan: any;
    listFitur: any = [];
    listPaket: any = [];
    listModalpaket: any = [];
    max_karyawan: any;
    listKaryawanModal: any;
    listOrganisasi: any;
    listDataCheckDetail: any;
    listJabatan: any;
    modalFilter: {
        karyawan_nama,
        m_jabatan_id,
        m_organisasi_id
    }
    check: boolean;
    isCheckDisabled: boolean;
    isCheckPerusahaanDisabled: boolean;
    interval: any;
    is_tutorial_settings: any;
    timeLeft: number = 60;
    versi_app_env = environment.versi_app;
    modelPengaturanAkun = {
        m_perusahaan_id: null
    };
    perusahaanTrialSelected: any;
    is_pilih_perusahaan_trial: boolean;
    is_masa_aktif_habis: boolean;
    step_pilih_perusahaan_trial: any;
    sisa_masa_aktif: any;
    sisa_masa_aktif_real: any;
    checkAll: boolean;
    jumlahKaryawanModalChecked: any;
    jumlahPerusahaanModalChecked: any;
    jumlahKaryawanAllPerusahaan: any;
    isRestorePerusahaan: boolean;
    listFiturModal: any = [];
    is_opsi_akun_gratis: any;
    fieldTextTypePassword: boolean;
    fieldTextTypeUlangiPassword: boolean;
    reminder_masa_aktif: any;
    is_session_admin_invoice: boolean;
    tipe_setting_invoice: any;
    is_setting_invoice_terisi: boolean;
    setting_invoice_branch: any;
    is_invoice_perusahaan_terbayar: boolean;
    kodeReminderInvoice: any;
    isset_invoice_pending: boolean;
    isStagging: boolean = false


    constructor(
        @Inject(DOCUMENT) private document: any,
        private TawktoService: TawktoService,
        private router: Router,
        private eventService: EventService,
        private authService: AuthenticationService,
        private modalService: NgbModal,
        private landaService: LandaService,
        private angularFireMessaging: AngularFireMessaging,
        private authenticationService: AuthenticationService,
        private readonly updates: SwUpdate,
        public translate: TranslateService,
        private clientStatusService: ClientStatusService
    ) {
        router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.activateMenu();
                this.checkRoutingAkses();

                //PENGECEKAN SETIAP GANTI HALAMAN
                //JIKA MASA AKTIF < 1 MUCULKAN MODAL AKUN GRATIS
                var routing = this.router.url.split('/', 3);
                if (routing[1] != 'user' && routing[1] + '/' + routing[2] != 'master/pembayaran-invoice' && routing[1] + '/' + routing[2] != 'master/pembayaran-invoice-branch' && routing[1] + '/' + routing[2] != 'user/expiredpage' && this.sisa_masa_aktif_real < 0 && this.is_opsi_akun_gratis == 1) {
                    if (this.isset_invoice_pending) {
                        this.openModalPerpanjangInvoicePending();
                    } else {
                        this.openModalAkunGratis();
                    }
                }

            }
        });
        translate.addLangs(['IND', 'ENG']);
    }

    @HostListener('window:scroll', [])
    onWindowScroll() {
        if (document.body.scrollTop > 50 ||
            document.documentElement.scrollTop > 50) {
            document.getElementById('page-topbar').classList.add('topbarputih');
            document.getElementById('topnav').classList.add('topnavbiru');
            if (document.getElementById('topnav-dashboard')) {
                document.getElementById('topnav-dashboard').classList.add('nav-linkfont');
            }
            if (document.getElementById('topnav-karyawan')) {
                document.getElementById('topnav-karyawan').classList.add('nav-linkfont');
            }
            if (document.getElementById('topnav-kehadiran')) {
                document.getElementById('topnav-kehadiran').classList.add('nav-linkfont');
            }
            if (document.getElementById('topnav-keuangan')) {
                document.getElementById('topnav-keuangan').classList.add('nav-linkfont');
            }
            if (document.getElementById('topnav-penggajian')) {
                document.getElementById('topnav-penggajian').classList.add('nav-linkfont');
            }
            if (document.getElementById('topnav-kpi')) {
                document.getElementById('topnav-kpi').classList.add('nav-linkfont');
            }
            if (document.getElementById('topnav-recruitment')) {
                document.getElementById('topnav-recruitment').classList.add('nav-linkfont');
            }
            if (document.getElementById('topnav-screening')) {
                document.getElementById('topnav-screening').classList.add('nav-linkfont');
            }
            if (document.getElementById('topnav-laporan')) {
                document.getElementById('topnav-laporan').classList.add('nav-linkfont');
            }
            if (document.getElementById('topnav-paket')) {
                document.getElementById('topnav-paket').classList.add('nav-linkfont');
            }
        }
        else {
            document.getElementById('page-topbar').classList.remove('topbarputih');
            document.getElementById('topnav').classList.remove('topnavbiru');
            if (document.getElementById('topnav-dashboard')) {
                document.getElementById('topnav-dashboard').classList.remove('nav-linkfont');
            }
            if (document.getElementById('topnav-karyawan')) {
                document.getElementById('topnav-karyawan').classList.remove('nav-linkfont');
            }
            if (document.getElementById('topnav-kehadiran')) {
                document.getElementById('topnav-kehadiran').classList.remove('nav-linkfont');
            }
            if (document.getElementById('topnav-keuangan')) {
                document.getElementById('topnav-keuangan').classList.remove('nav-linkfont');
            }
            if (document.getElementById('topnav-penggajian')) {
                document.getElementById('topnav-penggajian').classList.remove('nav-linkfont');
            }
            if (document.getElementById('topnav-kpi')) {
                document.getElementById('topnav-kpi').classList.remove('nav-linkfont');
            }
            if (document.getElementById('topnav-recruitment')) {
                document.getElementById('topnav-recruitment').classList.remove('nav-linkfont');
            }
            if (document.getElementById('topnav-screening')) {
                document.getElementById('topnav-screening').classList.remove('nav-linkfont');
            }
            if (document.getElementById('topnav-laporan')) {
                document.getElementById('topnav-laporan').classList.remove('nav-linkfont');
            }
            if (document.getElementById('topnav-paket')) {
                document.getElementById('topnav-paket').classList.remove('nav-linkfont');
            }
        }
    }

    ngOnInit(): void {
        this.detailproject = this.landaService.getDetailProject();
        // run();
        this.getClientDetail();
        this.listJabatan = [];
        this.listOrganisasi = [];
        this.jumlahSemuaPerusahaan = 0;
        this.jumlahPerusahaanTerhapus = 0;
        this.jumlahKaryawanAllPerusahaan = 0;
        this.isRestorePerusahaan = false;
        this.step_pilih_perusahaan_trial = 1;
        this.element = document.documentElement;

        this.configData = {
            suppressScrollX: true,
            wheelSpeed: 0.3,
        };
        this.listPerusahaan = [];
        this.is_tutorial_settings = 0;
        this.user = this.authService.getDetailUser();
        // this.checkConfirmVerifiedEmail();
        this.getPerusahaan();
        this.getPerusahaanData();
        this.pushUpdate();
        this.getNotifikasiPengumuman();
        this.setFitur();
        this.angularFireMessaging.messages.subscribe((payload) => {
            this.getNotifikasiPengumuman(true); // Force refresh on push notification
        });

        this.modalFilter = {
            karyawan_nama: '',
            m_jabatan_id: null,
            m_organisasi_id: null
        };

        if (this.user.bahasa && this.translate.currentLang !== this.user.bahasa) {
            this.translate.use(this.user.bahasa);
        }
        this.listJumlahKaryawan = 0;
        this.clientDetail = {
            max_perusahaan: 0,
            max_karyawan: 0,
            nama_paket: '-',
            jumlah_perusahaan: 0,
            tgl_aktif: '-',
            allmaxkaryawan: 0,
            jenis_usaha: '',
            nama: '',
            email: '',
            status: 3,
            paket_id: null,
            masa_aktif: null,
            is_paket_custom: false
        }
        this.dataPerusahaan = {
            jadwal_version: null
        }
        this.checkAll = false;
        this.getClientDetailpaket();
        // this.getlistJumlahKaryawan();
        this.is_tampil_paket = false;

        this.TawktoService.UpdateTawkUser(this.user);
        this.TawktoService.SetChatVisibility(true);
        // this.setTutorialIndex();
        this.authService.setTutorial(0, 'is_tutorial_running');

        this.setIntervalTutorial();
        this.getLogoPerusahaan();
        this.getPaketKlien();
        this.getDataKaryawanFilter();
        let temp = JSON.parse(localStorage.getItem('userDetail'));
        this.aksesPerusahaan = temp.akses_perusahaan;

        const currentHost = window.location.hostname;
        if (currentHost.includes('localhost') || currentHost.includes('humanis-app.venturo.pro')) {
            this.isStagging = true;
        }
    }

    isAdminPic(): boolean {
        return this.authService.isAdminPic();
    }

    setKodeReminderInvoice() {
        var tipe = this.tipe_setting_invoice == 2 ? this.user.m_perusahaan.id : 'all';
        var today = new Date();
        var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
        this.kodeReminderInvoice = tipe + '-' + date;
    }
    getLogoPerusahaan() {
        this.clientStatusService.getLogoNavbar().subscribe((res: any) => {
            this.imageSrc = res.data.list.logonya;
            this.adafoto = res.data.list.filefound;
        });
    }
    getPerusahaanData() {
        this.clientStatusService.getSettingBySession().subscribe((res: any) => {
            this.dataPerusahaan = res.data.setting;
        })
    }
    getPaketKlien() {
        this.clientStatusService.getPaketKlien().subscribe((res: any) => {
            this.jenis_paket = res.data.jenis_paket;
            // Jenis Paket Baru :
            // 1 = 'Presensi'
            // 2 = 'Payroll'
            // 3 = 'Presensi & Payroll (+Rekrutmen)'
        });
    }
    ubahadafoto() {
        this.adafoto = 0;
    }
    checkRoutingAkses() {
        // Skip route checking for super admin users
        if (this.user && this.user.tipe === 'super admin') {
            return;
        }

        if (typeof (this.user.akses) != 'undefined') {


            var routingAll = this.router.url;
            var arrRoutingAll = {
                '/kehadiran/jadwal-kerja-flat/1': 'kehadiran_jadwal_kerja_flat',
                '/kehadiran/jadwal-kerja-flat/2': 'kehadiran_jadwal_kerja_shift',
                '/master/lokasi_kantor/lokasi_kantor': 'master_lokasi_kantor',
                '/master/dinas_luar/dinas_luar': 'master_dinas_luar',
                // '/master/pembayaran-invoice/0' : 'invoice',

            }
            if (typeof (arrRoutingAll[routingAll]) != 'undefined') {
                var isChecked = this.checkAkses(arrRoutingAll[routingAll]);

                if (!isChecked) {
                    this.router.navigate(['/user/pagenotfound']);
                }
            }
            else {
                //PENGECEKAN KHUSUS INVOICE
                var routing = this.router.url.split('/', 3);
                if (routing[1] + '/' + routing[2] == 'master/pembayaran-invoice') {
                    if (this.checkAkses('invoice') || this.is_session_admin_invoice) {
                        isChecked = true;
                    }
                    if (!isChecked) {
                        this.router.navigate(['/user/pagenotfound']);
                    }
                }
                // var arrRoutingMulti = {
                //     '/keuangan/laporan-payroll' : ['keuangan_laporan_gaji','keuangan_laporan_bpjs','keuangan_laporan_pph'],
                //     '/kehadiran/laporan-hadir' : ['kehadiran_laporan_lembur', 'kehadiran_laporan_saldo_izin', 'kehadiran_laporan_izin', 'kehadiran_laporan_jadwal_kerja', 'kehadiran_laporan_riwayat_kehadiran']
                // }
                var data = {
                    '/keuangan/laporan-payroll': ['keuangan_laporan_gaji', 'keuangan_laporan_bpjs', 'keuangan_laporan_pph'],
                    '/kehadiran/laporan-hadir': ['kehadiran_laporan_lembur', 'kehadiran_laporan_saldo_izin', 'kehadiran_laporan_izin', 'kehadiran_laporan_jadwal_kerja', 'kehadiran_laporan_riwayat_kehadiran'],
                    '/kehadiran/laporan-hadir-new': ['kehadiran_laporan_lembur', 'kehadiran_laporan_saldo_izin', 'kehadiran_laporan_izin', 'kehadiran_laporan_jadwal_kerja', 'kehadiran_laporan_riwayat_kehadiran'],
                    '/kpi/pengaturan-kpi': ['kpi_new'],
                    '/user/approvalline': ['user_approvalline'],
                    '/company/direktori-perusahaan': ['direktori_perusahaan'],
                    '/karyawan/karyawan': ['karyawan_karyawan'],
                    '/kehadiran/lembur': ['kehadiran_lembur'],
                    '/kehadiran/riwayat-kehadiran': ['kehadiran_riwayat_kehadiran'],
                    '/kehadiran/izin': ['kehadiran_izin'],
                    '/keuangan/kasbon': ['keuangan_kasbon'],
                    '/keuangan/pengajuan-reimbursement': ['keuangan_pengajuan_reimbursement'],
                    '/keuangan/penggajian': ['keuangan_penggajian'],
                    '/keuangan/laporan-pembayaran-kasbon': ['keuangan_laporan_pembayaran_kasbon'],
                    '/keuangan/laporan-kasbon': ['keuangan_laporan_kasbon'],
                    '/keuangan/laporan-saldo-reimbursement': ['keuangan_laporan_saldo_reimbursement'],
                    '/keuangan/laporan-reimbursement': ['keuangan_laporan_reimbursement'],
                    '/keuangan/laporan-komponen-gaji': ['keuangan_laporan_komponen_gaji'],
                    '/keuangan/laporan-riwayat-gaji': ['keuangan_laporan_gaji'],
                    '/mutasi/laporan-terminasi': ['mutasi_laporan_terminasi_karyawan'],
                    '/mutasi/laporan-mutasi-karyawan': ['mutasi_laporan_mutasi_karyawan'],
                    '/mutasi/laporan-kontrak': ['mutasi_laporan_perubahan_kontrak'],
                    '/company/komplain': ['laporan_komplain_karyawan'],
                    '/user/hakakses': ['user_hakakses']
                }
                var routing = this.router.url.split('/', 3);

                if (routing.length == 3) {
                    var routingKey = String('/' + routing[1] + '/' + routing[2]);
                    if (typeof (data[routingKey]) != 'undefined') {
                        var isChecked = false;
                        data[routingKey].forEach((val: any, key: any) => {
                            if (this.checkAkses(val) == true) {
                                isChecked = true;
                            }
                        });
                        if (!isChecked) {
                            this.router.navigate(['/user/pagenotfound']);
                        }
                    }
                }
            }
        }

    }

    checkAkses(hakAkses) {
        return this.landaService.checkAkses(hakAkses, 'view');
    }
    checkUID(hakAkses) {
        return this.landaService.checkAkses(hakAkses, 'view');
    }
    checkAksesCustom(hakAkses, subAkses) {
        return this.landaService.checkAkses(hakAkses, subAkses);

    }

    /**
     * Buka popup Connect Channel (WhatsApp). Reset ke step 1.
     * Jika belum pernah connect, Platform & AI Agent otomatis terisi dan
     * user hanya perlu mengisi Channel Name.
     */
    openConnectChannel(modal) {
        if (this.waConnected) {
            // Sudah terhubung -> tampilkan info akun WhatsApp.
            this.connectStep = 4;
        } else {
            // Belum pernah connect -> form step 1.
            this.connectStep = 1;
            this.connectModel = {
                platform: this.platformList[0],   // WhatsApp, langsung terpilih
                // Channel Name otomatis terisi sesuai nama perusahaan.
                channelName: (this.user && this.user.m_perusahaan && this.user.m_perusahaan.nama) || '',
                aiAgent: this.aiAgentList[0],      // dummy Humanis Agent, otomatis terpilih
            };
        }
        this.modalService.open(modal, { size: 'lg', backdrop: 'static', centered: true, scrollable: true });
    }

    /** Submit step 1 -> lanjut ke step 2 (scan QR). */
    connectChannelNext() {
        if (!this.connectModel || !this.connectModel.channelName) {
            return;
        }
        this.connectStep = 2;
    }

    /**
     * Simulasi QR berhasil di-scan / channel terhubung (UI only).
     * Menandai channel sebagai terhubung, mengisi info dummy, dan
     * menampilkan step sukses.
     */
    simulateConnected() {
        this.waConnected = true;
        this.connectedInfo = {
            accountName: (this.connectModel && this.connectModel.channelName) || 'Humanis Hiraka',
            phone: '+62 812-3456-7890',
            lastConnected: '1 Juli 2026, 09:30',
        };
        // Tutup modal connect lalu tampilkan notif sukses kecil yang
        // otomatis tertutup dalam 5 detik (tanpa tombol).
        this.modalService.dismissAll();
        Swal.fire({
            icon: 'success',
            title: 'WhatsApp Terhubung',
            html: 'Channel <strong>' + this.connectedInfo.accountName + '</strong> berhasil terhubung.',
            timer: 5000,
            timerProgressBar: true,
            showConfirmButton: false,
        });
    }

    /** Reconnect / putuskan koneksi -> buka form QR lagi (UI only). */
    reconnectChannel() {
        this.connectStep = 2;
    }
    getNotifikasiPengumuman(forceRefresh: boolean = false) {
        this.clientStatusService.getNotifikasiPengumuman(forceRefresh).subscribe((res: any) => {
            this.listPengumuman = res.data.list;
        });
    }
    modalPengumuman(dataModal, val) {
        this.modalService.open(dataModal, { size: 'lg', scrollable: true, backdrop: 'static' });
        this.dataModalPengumuman = {
            judul: val.judul,
            isi: val.isi_pengumuman,
            tanggal: val.tanggal,
            penulis: val.penulis,
        }

    }

    // getlistJumlahKaryawan() {
    //     this.landaService.DataGet('/appdashboard/index', {}).subscribe((res: any) => {
    //         this.listJumlahKaryawan = res.data.totalKaryawan;
    //     });
    // }
    getClientDetailpaket() {
        this.clientStatusService.getMenuClientDashboard().subscribe((res: any) => {

            this.clientDetail.max_perusahaan = res.data.list.data.max_perusahaan;
            this.clientDetail.max_karyawan = res.data.list.data.max_karyawan;
            this.clientDetail.nama_paket = res.data.list.data.nama_paket;
            this.clientDetail.jumlah_perusahaan = res.data.list.data.perusahaan;
            this.clientDetail.tgl_aktif = res.data.list.data.tgl_aktif;
            this.clientDetail.allmaxkaryawan = res.data.list.data.jumlahkaryawan_total;
            this.clientDetail.jenis_usaha = res.data.list.data.jenis_usaha;
            this.clientDetail.nama = res.data.list.data.nama;
            this.clientDetail.email = res.data.list.data.email;
            this.clientDetail.status = res.data.list.data.status;
            this.clientDetail.paket_id = res.data.list.data.paket_id;
            this.clientDetail.masa_aktif = res.data.list.data.masa_aktif;
            this.clientDetail.is_paket_custom = res.data.list.data.is_paket_custom;
            this.max_perusahaan = res.data.list.data.max_perusahaan;
            // if(res.data.list.data.tipe_setting == 0){
            //     this.modalService.open(this.settingTipe, { scrollable: true, size: 'lg',backdrop: 'static',  keyboard: false});
            // }
        });
    }
    getAllPaket(modalPaket) {
        this.is_tampil_paket = false;
        this.getModalPaket();
        this.landaService.DataGet('/apppaket/indexformodal', {}).subscribe((res: any) => {
            this.listPaket = res.data.list;
            this.listFitur = res.data.fitur;
            this.listPaket.map((i) => { i.is_lihat_all = false; return i; });
            this.modalService.open(modalPaket, { size: 'lg' });

        });
    }

    getPaketReminder() {
        this.landaService.DataGet('/apppaket/indexformodalReminder', {}).subscribe((res: any) => {
            this.listPaket = res.data.list;
            this.listFitur = res.data.fitur;
            this.listPaket.map((i) => { i.is_lihat_all = false; return i; });
        });
    }

    getAllPaketData() {
        this.landaService.DataGet('/apppaket/indexForModalMasaAktif', {}).subscribe((res: any) => {
            this.listPaket = res.data.list;
            this.listFitur = res.data.fitur;
            this.listPaket.map((i) => { i.is_lihat_all = false; return i; });
        });
    }

    getModalPaket() {
        this.landaService.DataPost('/appclient/getKaryawanPerPerusahaanmodal', {}).subscribe((res: any) => {
            this.listModalpaket = res.data.list;
            this.listJumlahKaryawan = res.data.totalKaryawannya;
        });
    }
    lihatSemuaFitur(val, params) {
        val.is_lihat_all = params;
    }
    selectPerusahaan(modal) {
        this.isRestorePerusahaan = false;
        this.getPerusahaan();
        this.modalService.open(modal, { size: 'lg', backdrop: 'static', scrollable: true });
    }
    getPerusahaan(forceRefresh: boolean = false) {
        this.clientStatusService.getAksesKaryawan(forceRefresh)
            .subscribe((res: any) => {
                let temp = res.data.list;
                this.listPerusahaan = res.data.list
                // temp.forEach((val, key) => {
                //     if(this.aksesPerusahaan.includes(val.id) == true){
                //         this.listPerusahaan.push(val);
                //     }
                // })
                this.jumlahSemuaPerusahaan = res.data.jumlahSemuaPerusahaan;
                this.jumlahPerusahaanModalChecked = this.jumlahSemuaPerusahaan;
                this.listPerusahaanTerhapus = res.data.listPerusahaanTerhapus;
                this.jumlahPerusahaanTerhapus = res.data.jumlahPerusahaanTerhapus;
            });
    }

    editPerusahaan(modal, val) {
        modal.dismiss()
        this.router.navigate(['/company/perusahaan', val.id]);
    }

    editcompany() {

        this.router.navigateByUrl('/user', { skipLocationChange: true }).then(() =>
            this.router.navigate(['/company/perusahaan', this.user.m_perusahaan.id]));
    }
    deletePerusahaan(val) {
        if (val.id == this.user.m_perusahaan.id) {
            //JIKA PERUSAHAAN YANG DIHAPUS ADALAH PERUSAHAAN YANG SAAT INI SEDANG AKTIF
            this.landaService.alertError('Mohon Maaf', 'Kamu tidak dapat menghapus perusahaan yang saat ini sedang Kamu gunakan');
        } else if (this.tipe_setting_invoice == 2 && this.listPerusahaan.length <= 2) {
            //JIKA TIPE SETTING INVOICE PER BRANCH DAN PERUSAHAAN KURANG DARI 2
            this.landaService.alertError('Mohon Maaf', 'Saat ini kamu sedang menggunakan setting invoice per perusahaan, pastikan jumlah perusahaan lebih dari 1');
        } else {
            const data = {
                id: val.id,
                is_deleted: 1,
            };
            this.landaService.customAlert(
                'delete',
                'Apakah anda yakin ?',
                'Menghapus data perusahaan akan berpengaruh terhadap data lainnya',
                true,
                true,
                'Ya, Hapus data ini !',
                'Batalkan'
            ).then((result) => {
                if (result.value) {
                    this.landaService.DataPost('/appperusahaan/delete', data).subscribe((res: any) => {
                        if (res.status_code === 200) {
                            this.getPerusahaan();
                            this.landaService.alertSuccess('Berhasil', 'Data perusahaan telah dihapus !');
                            location.reload();
                        } else {
                            this.landaService.alertError('Mohon Maaf', res.errors);
                        }
                    });
                }
            });
        }
    }

    gantiPassword(modal) {
        this.modalService.open(modal, { size: 'md', backdrop: 'static' });
        this.model = {
            id: '',
            kode: '',
            nama: '',
            username: this.user.nama,
            twofa: 0,
            password: '',
            repassword: '',
            validasi: true,
            validasi_error: ''
        };
    }
    gantiBahasa(modalGBahasa) {
        this.modalService.open(modalGBahasa, { size: 'md', backdrop: 'static' });
    }
    savepasswords(is_confirm_verified_email) {
        const data = {
            model: this.model,
            email: this.user.email
        };
        this.landaService.customAlert(
            'warning',
            'Apakah anda yakin ?',
            'Mengubah password anda',
            true,
            true,
            'Ya, ubah password !'
        ).then(result => {
            if (result.value) {
                this.landaService.DataPost('/appkaryawan/updatepassword', data).subscribe((res: any) => {
                    if (res.status_code === 200) {
                        this.landaService.alertSuccess('Berhasil', 'Password telah diubah !');
                        this.switchUsername(this.model);
                    } else {
                        this.landaService.alertError('Mohon Maaf', res.errors);
                    }
                });
            }
        });

    }

    gantiTwoAuth(modal) {
        // this.modalService.open(this.confirmKey, { size: 'md', backdrop: 'static'  });
        const data = {
            id: '',
            uid: this.user.uid,
            email: this.user.email,
            client_uid: this.user.client,
            tipe: this.user.tipe,
        };
        this.landaService
            .DataGet('/appkaryawan/getTwoAuth', data)
            .subscribe((res: any) => {
                this.model = {
                    id: '',
                    kode: '',
                    nama: '',
                    username: this.user.nama,
                    twofa: res.data.twofa,
                    password: '',
                    repassword: '',
                    validasi: true,
                    validasi_error: ''
                };
                this.modalService.open(modal, { size: 'md', backdrop: 'static' });
            });
    }
    savetwoauth(model) {
        const data = {
            model: this.model,
            uid: this.user.uid,
            email: this.user.email,
            client_uid: this.user.client,
            tipe: this.user.tipe,
        };
        if (model.twofa == 1) {
            this.landaService.customAlert(
                'warning',
                'Apakah anda yakin ?',
                'Mengaktifkan Two Authentication',
                true,
                true,
                'Ya, aktifkan !'
            ).then(result => {
                if (result.value) {
                    this.landaService.DataPost('/appkaryawan/updatetwofa', data).subscribe((res: any) => {
                        if (res.status_code === 200) {
                            this.faqr1 = "";
                            this.faqr2 = "";
                            this.faqr3 = "";
                            this.faqr4 = "";
                            this.faqr5 = "";
                            this.faqr6 = "";
                            this.qrcode = res.data.list.qrtwofa;
                            this.modalService.open(this.confirmKey, { size: 'md', backdrop: 'static' });
                            // this.landaService.alertSuccess('Berhasil', 'Two Authentication telah diaktifkan !');
                        } else {
                            // this.landaService.alertError('Mohon Maaf', res.errors);
                        }
                    });
                }
            });
        } else {
            this.landaService.customAlert(
                'warning',
                'Apakah anda yakin ?',
                'Menonaktifkan Two Authentication',
                true,
                true,
                'Ya, nonaktifkan !'
            ).then(result => {
                if (result.value) {
                    this.modalService.open(this.discardKey, { size: 'md', backdrop: 'static' });
                }
            });
        }
    }

    checkauth(val) {
        const data = {
            model: this.model,
            uid: this.user.uid,
            email: this.user.email,
            client_uid: this.user.client,
            tipe: this.user.tipe,
            fa_qr: val
        };
        this.landaService.DataPost('/appkaryawan/checktwofa', data).subscribe((res: any) => {
            if (res.status_code === 200) {
                if (this.model.twofa == 1) {
                    this.landaService.alertSuccess('Berhasil', 'Two Authentication telah diaktifkan !');
                } else {
                    this.landaService.alertSuccess('Berhasil', 'Two Authentication telah dinonaktifkan !');
                }
                this.modalService.dismissAll();
            } else {
                this.landaService.alertError('Mohon Maaf', res.errors);
            }
        });
    }

    setFa(number) {
        if (number == 1) {
            document.getElementById("faqr2").focus();
        } else if (number == 2) {
            document.getElementById("faqr3").focus();
        } else if (number == 3) {
            document.getElementById("faqr4").focus();
        } else if (number == 4) {
            document.getElementById("faqr5").focus();
        } else if (number == 5) {
            document.getElementById("faqr6").focus();
        } else if (number == 6) {
            document.getElementById("faqr6").blur();
        }
    }

    setPerusahaan(val) {
        const data = {
            id: val.id,
            nama: val.nama,
            kode: val.kode,
        };

        this.landaService
            .DataPost('/site/setPerusahaan', data)
            .subscribe((res: any) => {
                this.authService.setDetailUser(res.data.user);
                // Switch perusahaan returns a freshly minted JWT (with the new
                // m_perusahaan + karyawan_id claims) so external consumers like
                // humanis-be-go can scope correctly. Persist it; subsequent
                // requests will pick it up via the Bearer header.
                if (res.data.access_token) {
                    this.authService.setAccessToken(res.data.access_token);
                }
                this.router.navigate(["/home"])
                    .then(() => {
                        location.reload();
                    });
            });
    }

    /**
     * Action logout
     */
    logout() {
        this.landaService
            .DataGet('/site/logout', {})
            .subscribe((res: any) => {
                this.authService
                    .logout()
                    .then((res: any) => {
                        window.location.reload();
                    })
                    .catch((error) => { });
            });
    }

    /**
     * On menu click
     */
    onMenuClick(event: any) {
        const nextEl = event.target.nextSibling;
        const screenWidth = screen.width;
        if (screenWidth >= 992) return false;

        if (nextEl && nextEl.classList) {
            nextEl.classList.toggle('show');
        } else {
            this.toggleMenubar();
        }
        return false;
    }

    ngAfterViewInit() {
        this.activateMenu();
        this.checkRoutingAkses();


    }

    /**
     * remove active and mm-active class
     */
    _removeAllClass(className) {
        const els = document.getElementsByClassName(className);
        while (els[0]) {
            els[0].classList.remove(className);
        }
    }

    /**
     * Togglemenu bar
     */
    toggleMenubar() {
        const element = document.getElementById('topnav-menu-content');
        element.classList.toggle('show');
    }

    /**
     * Activates the menu
     */
    private activateMenu() {
        const resetParent = (el: any) => {
            const parent = el.parentElement;
            if (parent) {
                parent.classList.remove('active');
                const parent2 = parent.parentElement;
                this._removeAllClass('mm-active');
                this._removeAllClass('mm-show');
                if (parent2) {
                    parent2.classList.remove('active');
                    const parent3 = parent2.parentElement;
                    if (parent3) {
                        parent3.classList.remove('active');
                        const parent4 = parent3.parentElement;
                        if (parent4) {
                            parent4.classList.remove('active');
                            const parent5 = parent4.parentElement;
                            if (parent5) {
                                parent5.classList.remove('active');
                            }
                        }
                    }
                }
            }
        };

        // activate menu item based on location
        const links = document.getElementsByClassName('side-nav-link-ref');
        let matchingMenuItem = null;
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < links.length; i++) {
            // reset menu
            resetParent(links[i]);
        }
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < links.length; i++) {
            // tslint:disable-next-line: no-string-literal

            if (location.pathname === links[i]['pathname']) {
                matchingMenuItem = links[i];
                break;
            }
        }

        if (matchingMenuItem) {
            const parent = matchingMenuItem.parentElement;
            /**
             * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
             * We should come up with non hard coded approach
             */
            if (parent) {
                parent.classList.add('active');
                const parent2 = parent.parentElement;
                if (parent2) {
                    parent2.classList.add('active');
                    const parent3 = parent2.parentElement;
                    if (parent3) {
                        parent3.classList.add('active');
                        const parent4 = parent3.parentElement;
                        if (parent4) {
                            parent4.classList.add('active');
                            const parent5 = parent4.parentElement;
                            if (parent5) {
                                parent5.classList.add('active');
                            }
                        }
                    }
                }
            }
        }
    }

    /**
     * on settings button clicked from topbar
     */
    onSettingsButtonClicked() {
        document.body.classList.toggle('right-bar-enabled');
    }

    /**
     * Fullscreen method
     */
    fullscreen() {
        document.body.classList.toggle('fullscreen-enable');
        if (
            !document.fullscreenElement &&
            !this.element.mozFullScreenElement &&
            !this.element.webkitFullscreenElement
        ) {
            if (this.element.requestFullscreen) {
                this.element.requestFullscreen();
            } else if (this.element.mozRequestFullScreen) {
                /* Firefox */
                this.element.mozRequestFullScreen();
            } else if (this.element.webkitRequestFullscreen) {
                /* Chrome, Safari and Opera */
                this.element.webkitRequestFullscreen();
            } else if (this.element.msRequestFullscreen) {
                /* IE/Edge */
                this.element.msRequestFullscreen();
            }
        } else {
            if (this.document.exitFullscreen) {
                this.document.exitFullscreen();
            } else if (this.document.mozCancelFullScreen) {
                /* Firefox */
                this.document.mozCancelFullScreen();
            } else if (this.document.webkitExitFullscreen) {
                /* Chrome, Safari and Opera */
                this.document.webkitExitFullscreen();
            } else if (this.document.msExitFullscreen) {
                /* IE/Edge */
                this.document.msExitFullscreen();
            }
        }
    }

    /**
     * Topbar light
     */
    topbarLight() {
        document.body.setAttribute('data-topbar', 'light');
        document.body.removeAttribute('data-layout-size');
    }

    /**
     * Set boxed width
     */
    boxedWidth() {
        document.body.setAttribute('data-layout-size', 'boxed');
        document.body.setAttribute('data-topbar', 'dark');
    }

    /**
     * Colored header
     */
    coloredHeader() {
        document.body.setAttribute('data-topbar', 'colored');
        document.body.removeAttribute('data-layout-size');
    }

    /**
     * Change the layout onclick
     * @param layout Change the layout
     */
    changeLayout(layout: string) {
        this.eventService.broadcast('changeLayout', layout);
        window.location.reload();
    }
    showTestAlert() {
        this.landaService.customAlert(
            'warning',
            'Apakah anda yakin ?',
            this.translate.instant('Kamu akan membatalkan tagihan dengan No. ') + "sjdjsjd",
            true,
            true,
            'Ya, Batalkan Tagihan ini !',
            'Kembali',
        ).then((res) => console.log('OK', res));
    }
    reloadCurrentRoute(uri: string) {
        this.router.navigateByUrl('/user', { skipLocationChange: true }).then(() =>
            this.router.navigate([uri]));
    }
    checkBatasPerusahaan(modal, uri: string) {
        this.landaService
            .DataGet('/appperusahaan/checkBatasPerusahaan', {})
            .subscribe((res: any) => {
                if (res.status_code != 200) {
                    this.landaService.alertError(
                        'Mohon Maaf',
                        res.errors
                    );
                } else {
                    modal.dismiss()
                    this.router.navigateByUrl('/user', { skipLocationChange: true }).then(() =>
                        this.router.navigate([uri]));
                }
            });

    }

    getClientDetail() {
        // if(routing[1] + '/' + routing[2] != 'master/pembayaran-invoice'){
        this.clientStatusService.getStatusClient().subscribe((res: any) => {
            this.jumlahKaryawanAllPerusahaan = res.data.list.data.jumlah_all_karyawan_perusahaan;
            this.max_karyawan = res.data.list.data.max_karyawan;
            this.listKaryawanModal = res.data.karyawan;
            this.is_opsi_akun_gratis = res.data.list.data.is_opsi_akun_gratis;

            this.tipe_setting_invoice = res.data.tipe_setting_invoice;
            this.is_session_admin_invoice = res.data.is_session_admin_invoice;
            this.is_setting_invoice_terisi = res.data.is_setting_invoice_terisi;
            this.setting_invoice_branch = res.data.setting_invoice_branch;
            this.is_invoice_perusahaan_terbayar = res.data.is_invoice_terbayar;
            this.clientDetail.is_paket_custom = res.data.list.data.is_custom;
            this.isset_invoice_pending = false;
            // if(routing[1] + '/' + routing[2] != 'master/pembayaran-invoice' && routing[1] + '/' + routing[2] != 'master/pembayaran-invoice-branch'){
            if (res.data.list.data.masa_trial != null && res.data.list.data.sisa_masa_aktif_real < 0 && res.data.list.data.is_opsi_akun_gratis == 1) {
                //PENGECEKAN JIKA MASA TRIAL MELEBIHI DAN MAX PERUSAHAAN 1
                if (res.data.isset_invoice_pending) {
                    this.isset_invoice_pending = true;
                    this.openModalPerpanjangInvoicePending();
                } else {
                    this.openModalAkunGratis();
                }
            } else if (this.tipe_setting_invoice == 2 && res.data.list.data.is_invoice_terbayar == 0) {
                //PENGECEKAN JIKA INVOICE PERBRANCH DAN ADA INVOICE BARU DARI UPGRADE
                this.is_masa_aktif_habis = true;
                if (this.checkRoutingPage()) {
                    this.openModalPerpanjang();
                }
            } else if (this.tipe_setting_invoice == 2 && res.data.list.data.jumlah_all_karyawan_perusahaan > res.data.list.data.max_karyawan) {
                //PENGECEKAN JIKA INVOICE PERBRANCH DAN JUMLAH KARYAWAN PERUSAHAAN MELEBIHI SLOT KARYAWAN
                this.is_masa_aktif_habis = true;
                if (this.checkRoutingPage()) {
                    this.router.navigate(["/master/pengaturan-max-karyawan"]);
                }
            } else if (this.tipe_setting_invoice == 1 && (res.data.list.data.jumlah_perusahaan > res.data.list.data.max_perusahaan || res.data.list.data.jumlah_all_karyawan_perusahaan > res.data.list.data.max_karyawan)) {
                //PENGECEKAN JIKA INVOICE KLIEN DAN JUMLAH PERUSAHAAN ATAU KARYAWAN MELEBIHI SLOT KARYAWAN
                this.is_masa_aktif_habis = true;
                if (this.checkRoutingPage()) {
                    this.router.navigate(["/master/pengaturan-max-karyawan"]);
                }
            } else {
                //PENGECEKAN JIKA MEMPUNYAI INVOICE PENDING TETAPI TIDAK HARUS DIBAYAR
                setTimeout(() => {
                    if ((this.checkAkses('invoice') || this.is_session_admin_invoice)) {
                        this.checkInvoicePending();
                    }
                }, 500);

                this.is_masa_aktif_habis = false;
            }
            // }

            if (res.data.list.data.masa_trial != null) {
                this.sisa_masa_aktif = res.data.list.data.masa_trial;
                this.sisa_masa_aktif_real = res.data.list.data.sisa_masa_aktif_real;
                this.reminder_masa_aktif = res.data.list.data.reminder_masa_aktif;
                this.checkMasaAktif(this.sisa_masa_aktif);
            }
        });
        // }
    }
    openModalSetting() {
        this.modalService.dismissAll();
        this.modalService.open(this.settingAkun, { scrollable: true, size: 'md', backdrop: 'static', keyboard: false });
    }

    checkMasaAktif(sisa_masa_aktif) {
        var arrReminder = [];
        const reminder = JSON.parse(localStorage.getItem('reminderMasaAktif'));
        if (reminder != null) {
            arrReminder = reminder.arrReminder;
        }
        if (sisa_masa_aktif <= this.reminder_masa_aktif && sisa_masa_aktif >= 1 && !arrReminder.includes(sisa_masa_aktif)) {
            setTimeout(() => {
                // this.getPaketReminder();
                const size_modal = this.clientDetail.status != 2 || !this.checkAkses('invoice') ? 'md' : 'md';
                // this.modalService.open(this.settingAkunBaru, { scrollable: true, size: size_modal, backdrop: 'static' });
                this.modalService.open(this.reminderMasaAktif, { scrollable: true, size: size_modal, backdrop: 'static' });
            }, 1000);
        } else if (sisa_masa_aktif > this.reminder_masa_aktif && sisa_masa_aktif < 1) {
            if (typeof (reminder) != 'undefined' && reminder != null) {
                localStorage.removeItem('reminderMasaAktif');
            }
        }

    }

    openModalAkunGratis() {
        this.is_masa_aktif_habis = true;
        if (this.checkRoutingPage()) {
            if (this.checkAkses('invoice') || (this.is_session_admin_invoice == true && this.tipe_setting_invoice == 2)) {
                // this.getFiturStandard();
                // this.getAllPaketData();
                // this.getPengaturanInvoice();
                this.modalService.dismissAll();
                //JIKA MEMPUNYAI HAK AKSES INVOICE ATAU LOGIN SEBAGAI ADMIN INVOICE DAN SETTING INVOICE TERISI DAN TIPE SETTING INVOICE PER BRANCH
                if (((this.checkAkses('invoice') || this.is_session_admin_invoice) && this.is_setting_invoice_terisi == true && this.tipe_setting_invoice == 2) || this.clientDetail.is_paket_custom) {
                    var size = 'md';
                } else {
                    var size = 'md';
                }
                this.modalService.open(this.settingAkun, { scrollable: false, size: size, backdrop: 'static', keyboard: false });
            } else {
                this.checkAksesInvoice();
            }
        }

    }

    saveReminderMasaAktifLocal() {
        var arrayMasaAktif = {
            arrReminder: []
        };
        const reminder = JSON.parse(localStorage.getItem('reminderMasaAktif'));
        if (reminder != null && reminder.arrReminder != null) {
            arrayMasaAktif = reminder;
        }
        arrayMasaAktif.arrReminder.push(this.sisa_masa_aktif)
        localStorage.setItem("reminderMasaAktif", JSON.stringify(arrayMasaAktif));
    }
    saveReminderInvoicePendingLocal() {
        var arrayInvoicePending = {
            arrReminder: []
        };
        const reminder = JSON.parse(localStorage.getItem('reminderInvoicePending'));
        if (reminder != null && reminder.arrReminder != null) {
            arrayInvoicePending = reminder;
        }
        arrayInvoicePending.arrReminder.push(this.kodeReminderInvoice)
        localStorage.setItem("reminderInvoicePending", JSON.stringify(arrayInvoicePending));
    }
    pengaturanAkun(is_perpanjang, data) {
        if (is_perpanjang == 0) {
            // if(this.listKaryawanModal.length > 0){}
            // this.getJabatan();
            // this.getOrganisasi();
            this.is_pilih_perusahaan_trial = true;
            this.step_pilih_perusahaan_trial = 2;
            this.modalService.open(this.settingKaryawanTrial, { scrollable: true, size: 'lg', backdrop: 'static', keyboard: false });

        } else {
            if (data.id != null && typeof (data.id) != 'undefined') {
                if (data.id == 3) {
                    this.checkTipeSettingInvoiceSebelum(data.id);
                } else {
                    this.router.navigate(["/master/pembayaran-invoice/reactivate" + '&&paket_id=' + data.id]);
                }
            } else {
                this.router.navigate(["/master/pembayaran-invoice/reactivate"]);
            }

        }
    }
    pilihPerusahaanTrial(val) {
        this.checkAll = false;
        this.modelPengaturanAkun.m_perusahaan_id = val.id;
        this.perusahaanTrialSelected = val;
        this.is_pilih_perusahaan_trial = false;
        this.getListKaryawanModal();
    }
    getListKaryawanModal() {
        this.getOrganisasi();
        this.getJabatan();

        const params = {
            m_jabatan_id: this.modalFilter.m_jabatan_id,
            m_organisasi_id: this.modalFilter.m_organisasi_id,
            nama: this.modalFilter.karyawan_nama,
            m_perusahaan_id: this.modelPengaturanAkun.m_perusahaan_id
        }

        this.landaService.DataPost('/appkaryawan/getKaryawanModal', params).subscribe((res: any) => {
            this.listKaryawanModal = res.data.list;
            // if(this.listKaryawanModal.length > this.max_karyawan){
            // 	this.modalService.open(this.settingKaryawanTrial, { scrollable: true, size: 'lg',backdrop: 'static',  keyboard: false});
            // }
        });


    }
    getOrganisasi() {
        const params = {
            m_perusahaan_id: this.modelPengaturanAkun.m_perusahaan_id,
        }
        this.landaService
            .DataGet('/apporganisasi/index', params)
            .subscribe((res: any) => {
                this.listOrganisasi = res.data.list;
                this.listOrganisasi.map((i) => { i.text = i.nama; return i; });

            });
    }
    getJabatan() {
        const params = {
            m_perusahaan_id: this.modelPengaturanAkun.m_perusahaan_id,
        }
        this.landaService.DataGet('/appjabatan/index', params).subscribe((res: any) => {
            this.listJabatan = res.data.list;
            this.listJabatan.map((i) => { i.text = i.nama; return i; });
        });
    }
    checkJumlahKaryawan() {
        var jumlah = 0;
        this.listKaryawanModal.forEach((val: any, key: any) => {
            if (val.check) {
                jumlah++;
            }
        });
        this.jumlahKaryawanModalChecked = jumlah;
        if (jumlah >= this.max_karyawan) {
            this.isCheckDisabled = true;
        } else {
            this.isCheckDisabled = false;
        }
    }

    checkJumlahPerusahaan() {
        var jumlah = 0;
        this.listPerusahaanTerhapus.forEach((val: any, key: any) => {
            if (val.check) {
                jumlah++;
            }
        });
        this.jumlahPerusahaanModalChecked = jumlah + this.jumlahSemuaPerusahaan;
        if (this.jumlahPerusahaanModalChecked >= this.max_perusahaan) {
            this.isCheckPerusahaanDisabled = true;
        } else {
            this.isCheckPerusahaanDisabled = false;
        }
    }
    saveStatusKaryawan() {
        const data = {
            list_karyawan: this.listKaryawanModal,
            m_perusahaan_id: this.modelPengaturanAkun.m_perusahaan_id
        }
        this.landaService.DataPost('/appdashboard/saveStatusKaryawan', data).subscribe((res: any) => {
            if (res.status_code === 200) {
                this.landaService.alertSuccess('Berhasil', 'Data Karyawan telah disimpan !');
                this.modalService.dismissAll();
                this.setPerusahaan(this.perusahaanTrialSelected);

            } else {
                this.landaService.alertError('Mohon Maaf', res.errors);
            }
        });
    }
    setFitur() {
        this.clientStatusService.setFitur(this.user.akses)
            .subscribe((res: any) => {
                this.authService.setDetailUser(res.data.user);
            });
    }

    switchLang(lang: string) {
        this.landaService.DataPost('/site/setBahasa', {
            bahasa: lang,
        }).subscribe((res: any) => {
            /**
             * Simpan detail user ke session storage
             */
            if (res.status_code == 200) {
                this.authenticationService
                    .setDetailUser(res.data.user)
                    .then(() => {
                        window.location.reload();
                    })
                    .catch((error) => {
                        this.landaService.alertError('Mohon Maaf gagal Memuat bahasa', res.errors);
                    });
            } else {
                this.landaService.alertError('Mohon Maaf gagal Memuat bahasa', res.errors);
            }
        });

    }
    switchUsername(data) {
        this.landaService.DataPost('/site/setUsername', data).subscribe((res: any) => {
            /**
             * Simpan detail user ke session storage
             */
            if (res.status_code == 200) {
                this.authenticationService
                    .setDetailUser(res.data.user)
                    .then(() => {
                        window.location.reload();
                    })
                    .catch((error) => {
                        this.landaService.alertError('Mohon Maaf gagal Memuat username', res.errors);
                    });
            } else {
                this.landaService.alertError('Mohon Maaf gagal Memuat username', res.errors);
            }
        });

    }
    showtampilpaket() {
        this.is_tampil_paket = true;
    }
    hiddentampilpaket() {
        this.is_tampil_paket = false;
    }

    settingInputClient(val, modalSettingInput) {
        const data = {
            tipe_setting: val,
        };
        this.landaService.DataGet('/appclient/settinginput', data).subscribe((res: any) => {
            if (res.status_code === 200) {
                this.modalService.dismissAll();
                if (res.data.list.tipe_setting == 1) {
                    this.router.navigate(['/company/tambah-perusahaan', this.user.m_perusahaan.id]);
                } else {

                    this.landaService.alertSuccess(this.translate.instant('Berhasil'), this.translate.instant('Setting Input Data telah disimpan !'));
                }
            } else {
                this.landaService.alertError(this.translate.instant('Mohon Maaf'), res.errors);
            }
        });
    }

    setIntervalTutorial() {
        this.interval = setInterval(() => {
            var routing = this.router.url.slice(0, -2);
            this.user = this.authService.getDetailUser();
            if (routing != '/company/tambah-perusahaan/' && this.user.is_tutorial == 1) {
                if (
                    (typeof (this.user.is_tutorial_departemen) == 'undefined' || this.user.is_tutorial_departemen == 0) ||
                    (typeof (this.user.is_tutorial_jabatan) == 'undefined' || this.user.is_tutorial_jabatan == 0) ||
                    (typeof (this.user.is_tutorial_jadwal) == 'undefined' || this.user.is_tutorial_jadwal == 0) ||
                    (typeof (this.user.is_tutorial_check_clock) == 'undefined' || this.user.is_tutorial_check_clock == 0)
                ) {
                    if (typeof (this.user.is_tutorial_running) == 'undefined' || this.user.is_tutorial_running == 0) {
                        this.setTutorialIndex();
                        this.authService.setTutorial(1, 'is_tutorial_running');

                    }
                } else {
                    clearInterval(this.interval);
                }
            }
        }, 2000)
    }
    setTutorialIndex() {
        var routing = this.router.url.slice(0, -2);
        if (routing != '/company/tambah-perusahaan/' && this.user.is_tutorial == 1) {
            if (
                ((typeof (this.user.is_tutorial_departemen) == 'undefined' || this.user.is_tutorial_departemen == 0) ||
                    (typeof (this.user.is_tutorial_jabatan) == 'undefined' || this.user.is_tutorial_jabatan == 0)) &&
                (this.user.akses.company_jabatan.view == true || this.user.akses.company_organisasi.view == true)
            ) {
                this.authService.setTutorial(1, 'is_tutorial_running');

                this.modalService.open(this.modalTutorialAwal, { scrollable: true, size: 'sm', backdrop: 'static', keyboard: false });


            }
            else if (
                ((typeof (this.user.is_tutorial_jadwal) == 'undefined' || this.user.is_tutorial_jadwal == 0) ||
                    (typeof (this.user.is_tutorial_check_clock) == 'undefined' || this.user.is_tutorial_check_clock == 0)) &&
                (this.user.akses.master_lokasi_kantor.view == true || this.user.akses.kehadiran_jadwal_kerja_flat.view == true)
            ) {
                this.authService.setTutorial(1, 'is_tutorial_running');
                var keteranganSteps;
                var nextLabell = this.translate.instant('Selanjutnya');
                var prevLabell = this.translate.instant('Sebelumnya');
                var doneLabell = this.translate.instant('Selesai');
                if ((typeof (this.user.is_tutorial_jadwal) == 'undefined' || this.user.is_tutorial_jadwal == 0) && this.user.akses.kehadiran_jadwal_kerja_flat.view == true) {
                    keteranganSteps = this.translate.instant('Klik Menu Kehadiran --> Jadwal Kerja --> Jadwal Flat');
                } else if ((typeof (this.user.is_tutorial_check_clock) == 'undefined' || this.user.is_tutorial_check_clock == 0) && this.user.akses.master_lokasi_kantor.view == true) {
                    keteranganSteps = this.translate.instant('Klik Menu Kehadiran --> Check Clock');
                }
                setTimeout(function () {

                    this.introJS = introJs();
                    this.introJS.setOptions({
                        steps: [
                            {
                                element: '#steps-kehadiran',
                                intro: keteranganSteps,
                                position: 'left'
                            },

                        ],
                        nextLabel: nextLabell,
                        prevLabel: prevLabell,
                        doneLabel: doneLabell,
                        exitOnOverlayClick: false,

                    });
                    this.introJS.start();
                }, 500);

            }
            else {
                clearInterval(this.interval);
            }
        }
    }
    setTutorialSettingAwal() {
        window.scrollTo(0, 0);
        var keteranganSteps = this.translate.instant('Klik tombol Pengaturan');
        var nextLabell = this.translate.instant('Selanjutnya');
        var prevLabell = this.translate.instant('Sebelumnya');
        var doneLabell = this.translate.instant('Selesai');
        setTimeout(function () {
            this.introJS = introJs();
            this.introJS.setOptions({
                steps: [

                    {
                        element: '#steps-settings',
                        intro: keteranganSteps,
                        position: 'left'
                    },

                ],
                nextLabel: nextLabell,
                prevLabel: prevLabell,
                doneLabel: doneLabell,
                // exitOnOverlayClick: false,

            });
            this.introJS.start();
        }, 500);
    }
    setTutorialSettings() {
        if (
            ((typeof (this.user.is_tutorial_departemen) == 'undefined' || this.user.is_tutorial_departemen == 0) ||
                (typeof (this.user.is_tutorial_jabatan) == 'undefined' || this.user.is_tutorial_jabatan == 0)) &&
            (this.is_tutorial_settings == 0) &&
            (this.user.akses.company_jabatan.view == true || this.user.akses.company_organisasi.view == true)
        ) {
            this.is_tutorial_settings = 1;
            var keteranganSteps = this.translate.instant('Klik tombol Struktur');
            var nextLabell = this.translate.instant('Selanjutnya');
            var prevLabell = this.translate.instant('Sebelumnya');
            var doneLabell = this.translate.instant('Selesai');
            setTimeout(function () {

                this.introJS = introJs();
                this.introJS.setOptions({
                    steps: [

                        {
                            element: '#step-struktur',
                            intro: keteranganSteps,
                            position: 'left'
                        },

                    ],
                    nextLabel: nextLabell,
                    prevLabel: prevLabell,
                    doneLabel: doneLabell,
                    // exitOnOverlayClick: false,

                });
                this.introJS.start();
            }, 500);
        }

    }
    LewatiTutorial() {
        const data = {
            karyawan_data_id: this.user.karyawan_data_id,
        };
        this.landaService.DataPost('/appdashboard/saveStatusTutorialAll', data).subscribe((res: any) => {
            if (res.status_code == 200) {
                this.authService.setTutorial(1, 'is_tutorial_perusahaan');
                this.authService.setTutorial(1, 'is_tutorial_departemen');
                this.authService.setTutorial(1, 'is_tutorial_jabatan');
                this.authService.setTutorial(1, 'is_tutorial_jadwal');
                this.authService.setTutorial(1, 'is_tutorial_check_clock');

                this.user.is_tutorial_perusahaan = 1;
                this.user.is_tutorial_departemen = 1;
                this.user.is_tutorial_jabatan = 1;
                this.user.is_tutorial_jadwal = 1;
                this.user.is_tutorial_jabatan = 1;

                // if(!this.isDemo){
                //     location.reload();
                // }
            }
        });
    }
    pushUpdate() {
        this.clientStatusService.getCekVersi().subscribe((res: any) => {
            if (this.user.versi_app < res.data.data.versi_app) {
                this.checkVersiApp();
            }
        });
    }
    checkVersiApp() {
        this.landaService.DataGet('/site/updatesistem', {}).subscribe((res: any) => {
            if (res.status_code == 200) {
                this.landaService.customAlert(
                    'success',
                    'Berhasil !',
                    'Berhasil Update Sistem Aplikasi',
                    true,
                    false,
                    'Tutup'
                ).then((result) => {
                    this.updates.activateUpdate().then(() => document.location.reload());
                    this.authService.logout().then((res: any) => {
                        window.location.href = window.location.pathname + '?timestamp=' + new Date().getTime(); // Memuat ulang dengan query string unik
                    }).catch((error) => { });
                });
            }
        });
        // this.landaService.DataGet('/backofficepengaturan/index', {}).subscribe((res: any) => {
        //     if(this.versi_app_env < res.data.data.versi_app) {
        //         Swal.fire({
        //             title: this.translate.instant('Perhatian'),
        //             text:
        //             this.translate.instant("Terdapat pembaruan pada sistem, silahkan klik Perbarui Sistem"),
        //             icon: "warning",
        //             showCancelButton: true,
        //             confirmButtonColor: "#34c38f",
        //             cancelButtonColor: "#f46a6a",
        //             confirmButtonText: this.translate.instant("Perbarui Sistem"),
        //         }).then((result) => {
        //             if (result.value) {
        //                 this.doAppUpdate();
        //             }
        //         });
        //     }else{
        //         Swal.fire({
        //             text:
        //             this.translate.instant("Anda sudah Menggunakan Versi Terbaru dari Aplikasi"),
        //             icon: "success",
        //             confirmButtonColor: "#f46a6a",
        //             confirmButtonText: this.translate.instant("Tutup"),
        //             showCancelButton: false,
        //         }).then((result) => {

        //         });
        //     }
        // });
    }
    showAppUpdateAlert() {
        // Use MatDialog or ionicframework's AlertController or similar
        this.landaService.customAlert(
            'warning',
            'Perhatian !',
            'Terdapat pembaruan pada sistem, silahkan klik Perbarui Sistem',
            true,
            true,
            'Perbarui Sistem'
        ).then((result) => {
            if (result.value) {
                this.doAppUpdate();
            }
        });
    }

    doAppUpdate() {
        this.updates.activateUpdate().then(() => document.location.reload());
    }

    checkConfirmVerifiedEmail() {

        this.landaService
            .DataGet("/appclient/getStatusConfirmEmail", {
                email: this.user.email
            })
            .subscribe((res: any) => {
                if (res.data == 1) {
                    this.modalService.open(this.modalGPasswordVerifiedEmail, { size: 'md', backdrop: 'static', keyboard: false });
                    this.model = {
                        id: '',
                        kode: '',
                        nama: '',
                        username: this.user.nama,
                        twofa: 0,
                        password: '',
                        repassword: '',
                        validasi: true,
                        validasi_error: ''
                    };
                }
            });
    }

    restorePerusahaan() {
        var arrListPerusahaan = [];
        this.listPerusahaanTerhapus.forEach((val: any, key: any) => {
            if (val.check == true) {
                arrListPerusahaan.push(val.id);
            }
        });
        const params = {
            arrListPerusahaan: Object.assign(arrListPerusahaan)
        }
        this.landaService.DataPost('/appperusahaan/restoreCustom', params).subscribe((res: any) => {
            if (res.status_code === 200) {
                this.landaService.alertSuccess('Berhasil', 'Data perusahaan telah disimpan !');
                location.reload();
            } else {
                this.landaService.alertError('Mohon Maaf', res.errors);
            }
        });
    }
    checkKaryawanModal(val) {
        if (!this.isCheckDisabled || val.check) {
            if (!val.check) {
                val.check = true;
            } else {
                val.check = false
            }
            // val.check != val.check;
        }
    }
    checkAllKaryawanModal(length) {
        this.listKaryawanModal.map((i) => {
            i.check = false;
            return i;
        });
        for (let index = 1; index <= length; index++) {
            if (index <= this.listKaryawanModal.length) {

                this.listKaryawanModal[index - 1].check = this.checkAll;
            }
        }

    }

    checkInvoicePending() {
        this.setKodeReminderInvoice();
        var arrReminder = [];
        const reminder = JSON.parse(localStorage.getItem('reminderInvoicePending'));
        if (reminder != null) {
            arrReminder = reminder.arrReminder;
        }
        if (!arrReminder.includes(this.kodeReminderInvoice)) {
            const params = {
                m_perusahaan_id: this.tipe_setting_invoice == 2 ? this.user.m_perusahaan.id : null,
                is_invoice_aktif: true,
            }
            this.landaService.DataGet('/appclient/checkInvoicePending', params).subscribe((res: any) => {
                if (res.data.data) {
                    this.modalService.open(this.reminderInvoicePending, { scrollable: true, size: 'md', backdrop: 'static' });
                }
            });
        }

    };

    checkInvoicePendingReminder() {
        this.setKodeReminderInvoice();
        var arrReminder = [];
        const reminder = JSON.parse(localStorage.getItem('reminderInvoicePending'));
        if (reminder != null) {
            arrReminder = reminder.arrReminder;
        }
        if (!arrReminder.includes(this.kodeReminderInvoice)) {
            this.checkInvoicePendingAktif();
        }
    }

    checkInvoicePendingAktif() {
        const params = {
            m_perusahaan_id: this.tipe_setting_invoice == 2 ? this.user.m_perusahaan.id : null,
            is_invoice_aktif: false,
        }
        var paramLink = '&&paket_id=' + this.clientDetail.paket_id + '&&masa_aktif=' + this.clientDetail.masa_aktif
        this.landaService.DataGet('/appclient/checkInvoicePending', params).subscribe((res: any) => {
            if (res.data.data) {
                //JIKA ADA INVOICE PENDING DAN SETTING INVOICE PERBRANCH MAKA ARAHKAN UNTUK PERPANJANG DI HALAMAN INVOICE
                if (this.tipe_setting_invoice == 2) {
                    this.perpanjangKontrakInvoiceBranch();
                } else {
                    this.gotToinvoicePage(paramLink);
                }
            } else {
                //JIKA TIDAK ADA INVOICE PENDING DAN SETTING INVOICE PER BRANCH DAN TIPE ADMIN DAN MASA AKTIFNYA HABIS, ARAHKAN GENENRATE ULANG
                if (this.tipe_setting_invoice == 2 && this.authService.isAdminPic()) {
                    if (this.sisa_masa_aktif_real < 0) {
                        this.router.navigate(["/master/pembayaran-invoice-branch/generateInvoice"]);
                    } else {
                        this.router.navigate(["/master/pembayaran-invoice-branch/0"]);
                    }
                } else {
                    this.gotToinvoicePage(paramLink);
                }

            }
        });
    }

    getFiturStandard() {
        this.landaService.DataGet('/appclient/getFiturStandard', {}).subscribe((res: any) => {
            this.listFiturModal = res.data.data.fitur_listed;
        });
    }

    toggleFieldTextTypePassword() {
        this.fieldTextTypePassword = !this.fieldTextTypePassword;
    }
    toggleFieldTextUlangiPassword() {
        this.fieldTextTypeUlangiPassword = !this.fieldTextTypeUlangiPassword;
    }
    validatePassword() {
        if (this.model.password != '' && this.model != null) {
            var validasi = this.landaService.validasiPassword(this.model.password);
            this.model.validasi = validasi.status;
            if (!validasi.status) {
                this.model.validasi_error = validasi.error;
            } else {
                this.model.validasi_error = '';
            }
        } else {
            this.model.validasi = true;
        }
    }
    getPengaturanInvoice() {
        this.landaService.DataGet('/appinvoicebranch/getPengaturan', {}).subscribe((res: any) => {
            if (res.status_code == 200) {
                this.tipe_setting_invoice = res.data.tipe_setting_invoice;
                this.is_session_admin_invoice = res.data.is_session_admin_invoice;
                this.is_setting_invoice_terisi = res.data.is_setting_invoice_terisi;
            }
        });
    }
    perpanjangKontrakInvoiceBranch() {
        var paramLink = '&&paket_id=' + this.setting_invoice_branch.paket_id + '&&masa_aktif=' + this.setting_invoice_branch.masa_aktif + '&&m_perusahaan_id=' + this.user.m_perusahaan.id
        this.gotToinvoicePage(paramLink);
    }

    gotToinvoicePage(params) {
        this.router.navigate(["/master/pembayaran-invoice/reactivate" + params]);
    }

    openModalPerpanjang() {
        this.modalService.open(this.modalPerpanjang, { scrollable: true, size: 'md', backdrop: 'static', keyboard: false });
    }

    checkAksesInvoice() {
        this.router.navigate(["/user/expiredpage"]);
    }
    checkRoutingPage() {
        var routing = this.router.url.split('/', 3);
        if (routing[1] + '/' + routing[2] != 'master/pembayaran-invoice' && routing[1] + '/' + routing[2] != 'master/pembayaran-invoice-branch') {
            return true;
        } else {
            return false;
        }
    }
    generateReferral() {
        const params = {
            karyawan_id: this.user.karyawan_data_id,
        }
        this.landaService.DataGet('/api_referral/generate_referral', params).subscribe((res: any) => {
            if (res.status_code === 200) {
                this.landaService.alertSuccess('Berhasil', 'Berhasil mendaftarkan referral, harap cek email anda !');
                window.open(res.data.redirect, "_blank");
            } else {
                // this.landaService.alertError('Mohon Maaf', res.errors.message);
                window.open(res.errors.redirect, "_blank");
            }
        });
    }
    checkTipeSettingInvoiceSebelum(paket_id) {
        //JIKA PILIH ENTERPISE DAN TIPE SETTING INVOICE SEBELUMNYA PER PERUSAHAAN, MAKA JADIKAN TIPE SETTING INVOICE YANG SEKARANG MENJADI PER PERUSAHAAN JUGA
        var params = '&&paket_id=' + paket_id;
        this.landaService.DataPost('/apppembayaraninvoice/checkSettingSebelum', {}).subscribe((res: any) => {
            if (res.status_code === 200) {
                if (res.data.settingan_invioce_sebelum) {
                    // this.landaService.DataPost('/apppembayaraninvoice/saveSettingInvoiceClient', {}).subscribe((resSave: any) => {
                    //     if(resSave.status_code === 200) {
                    //         this.tipe_setting_invoice = resSave.data.tipe_setting_invoice;
                    //         this.checkInvoicePendingAktif();
                    //     }else {
                    //         this.landaService.alertError('Mohon Maaf', resSave.errors);
                    //     }
                    // });

                    //MUNCULKAN OPSI INVOICE PER BRANCH ATAU PER CLIENT
                    Swal.fire({
                        title: this.translate.instant('Sistem mendeteksi kamu memakai invoice per perusahaan di pengaturan invoice sebelumnya !'),
                        text: this.translate.instant('apakah anda ingin tetap meggunakan invoice per perusahaan ?'),
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#34c38f',
                        cancelButtonColor: '#f46a6a',
                        confirmButtonText: this.translate.instant('Invoice per perusahaan'),
                        cancelButtonText: this.translate.instant('Kembali ke invoice keseluruhan'),
                        width: '50%',
                        allowOutsideClick: false
                    }).then((result) => {
                        if (result.value) {
                            this.landaService.DataPost('/apppembayaraninvoice/saveSettingInvoiceClient', {}).subscribe((resSave: any) => {
                                if (resSave.status_code === 200) {
                                    this.tipe_setting_invoice = resSave.data.tipe_setting_invoice;
                                    this.checkInvoicePendingAktif();
                                } else {
                                    this.landaService.alertError('Mohon Maaf', resSave.errors);
                                }
                            });
                        } else {
                            this.gotToinvoicePage(params)
                        }
                    });
                } else {
                    this.gotToinvoicePage(params)
                }
            } else {
                this.gotToinvoicePage(params)
            }
        });
    }
    openModalPerpanjangInvoicePending() {
        this.is_masa_aktif_habis = true;
        this.modalService.open(this.modalPerpanjangInvoicePending, { scrollable: true, size: 'md', backdrop: 'static', keyboard: false });
    }
    perpanjangInvoice() {
        var paramLink = '&&paket_id=' + this.clientDetail.paket_id + '&&masa_aktif=' + this.clientDetail.masa_aktif;
        this.gotToinvoicePage(paramLink);
    }
    getDataKaryawanFilter() {
        // console.log(this.idkaryawanfilter);
        // if (this.idkaryawanfilter && this.idkaryawanfilter.trim().length >= 3) {
        //     console.log('aa');
        //     this.landaService.DataGet('/appkaryawan/getData', this.model).subscribe((res: any) => {
        //         this.listKaryawanFilter = res.data.list;
        //     });
        // } else {
        //     this.listKaryawanFilter = [];
        // }
    }

    getKaryawanSearch(val) {
        if (val.length >= 3) {
            this.landaService.DataGet('/appkaryawan/filterKaryawan', { nama: val }).subscribe((res: any) => {
                this.listKaryawanFilter = res.data.list;
            });
        }

    }

    resetCalculations() {
        this.listKaryawanFilter = [];
    }
    searchKaryawan(val) {
        window.location.href = "/karyawan/karyawan/" + val;
    }
}